import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { TabOpenService } from '@services/tab-open.service';
import { PermissionPipe } from '@shared/pipes/permission';
import { ActionName } from '@shared/enums/action-name';
import { Tabs } from '@enums/tab.enum';
import { Constants } from '@shared/models/constants';
import { NotificationsService } from '@shared/services/notification';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { SaItemService } from 'src/app/fs-lte/services/price-book/sa-item/sa-item.service';
import { ProductItemType } from '@fs/enums/common-enums';
import { FSliteTradeService } from '@fs/services/product-category/trades.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'sa-item-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class SaItemViewComponent implements OnInit {
  //#region Variable Declarations
  details: any;
  actionName = ActionName;
  inputParams: any;
  tabCounter: number;
  defaultImage: string = Constants.DefaultImagePaths.ServiceAgreementItem;
  qbVersion: string = "";
  attachments: GridDataResult = { data: [], total: 0 };
  DefaultImagePath = Constants.DefaultImagePaths.ServiceAgreementItem;
  productItemType = ProductItemType;
  saCategories = [];
  saCategoriesPlaceHolder = "";
  //#endregion

  constructor(private toastr: NotificationsService,
    private permissionPipe: PermissionPipe,
    private authServ: AuthService,
    private tabServ: TabOpenService,
    private commonMethods: CommonMethods,
    private showspinner: SpinnerService,
    private httpSaItem: SaItemService,
    private fSliteTradeService: FSliteTradeService,
    private viewContainerRef: ViewContainerRef) {
    this.qbVersion = (this.authServ.getCompanyQBType()).toLowerCase();
  }

  ngOnInit() {
    const categoryServ = this.fSliteTradeService.fetch("", {}, "");
    const agreementServ = this.httpSaItem.GetSaItem(this.inputParams.ID);

    this.showspinner.showloader(this.viewContainerRef, this.tabCounter, Constants.defaultSpinnertimeout);
    forkJoin([categoryServ, agreementServ]).pipe().subscribe(res => {
      const categories = res[0].Children.filter(x => !x.IsSealed && x.IsVisible);
      this.saCategoriesPlaceHolder = res[1].ServiceAgreementCategories.length + " categories selected";
      this.getAgreementDetails(res[1]);
      this.parseSaCategories(categories);
    }, error => {
      this.toastr.showMultiLineError(error.error.Message, "Error");
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    });
  }
  refreshTab() {
    this.getServiceAgreementItem(0);
  }
  checkIsNotImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (!CommonMethods.CheckNullOrUndefined(dataItem["ExternalAttachment"])) {
        fileName = dataItem["ExternalAttachment"]["AttachmentPath"]; //dataItem["ExternalAttachment"]["FileName"];
      }
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        if (!this.commonMethods.ValidExtension(fileName, exts))
          return true;
        else
          return false;
      }
      else {
        if (!CommonMethods.CheckNullOrUndefined(dataItem.FilePath) && dataItem.FilePath.indexOf("https://mpsuitedevstore.blob.core.windows.net") < 0) {
          return true;
        }
      }
    }
    else
      return false;
  }
  openEditTab() {
    if (!this.permissionPipe.transform(ActionName.EditItem)) {
      return
    }
    this.tabServ.ReplaceTab(
      {
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteServiceAgreementItem,
          params: { ID: this.inputParams.ID },
          tabTitle: 'Agreement - ' + this.details.ItemNumber
        }
      });
  }
  private getServiceAgreementItem(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter, instantSpinnerTime);
    this.httpSaItem.GetSaItem(this.inputParams.ID
    ).subscribe(
      response => {
        this.getAgreementDetails(response);
      }, error => {
        this.toastr.showMultiLineError(error.error.Message, "Error");
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      });
  }
  private getAgreementDetails(response) {
    this.details = response;
    let PriceBookItem = {};
    PriceBookItem['IsFrequentlyUsed'] = this.details.IsFrequentlyUsed;
    PriceBookItem['IsDescriptionEditAllowed'] = this.details.IsDescriptionEditAllowed;
    PriceBookItem['IsTaxable'] = this.details.IsTaxable;
    this.details['PriceBookItem'] = PriceBookItem;
    this.attachments = { data: response.Attachments, total: response.Attachments.length };
    this.attachments.data.forEach(x => {
      x.checkIsNotImage = this.checkIsNotImage(x);
      x.IsImage = !x.checkIsNotImage;
      x.UploadedBy = !CommonMethods.CheckNullOrUndefined(x.UploadedBy) ? x.UploadedBy["FirstName"] + " " + x.UploadedBy["LastName"] : "";
    });
    this.DefaultImagePath = Constants.DefaultImagePaths.ServiceAgreementItem; // Reset image to default
    this.DefaultImagePath = this.attachments.data.find(x => x.IsDefaultImage) != undefined ? this.attachments.data.find(x => x.IsDefaultImage).FilePath : this.DefaultImagePath;

    this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    if (!CommonMethods.CheckNullOrUndefined(this.details.Category.FullName)) {
      this.details.Category.FullName = this.details.Category.FullName.replace(/\//g, ':');
    }
  }
  private parseSaCategories(categories) {
    this.details.ServiceAgreementCategories.forEach(id => {
      categories.forEach(t => {
        if (t.ID == id) {
          this.saCategories.push(this.setChildNodesEmpty(t));
          return;
        }
        else {
          this.findChildNodes(t, id, []);
        }
      });
    });
  }
  private findChildNodes(source, id, parent) {
    source.Children.forEach(x => {
      if (x.ID == id) {
        if(source.Level == 2 && !this.saCategories.find(sa => sa.ID == source.ID)) 
          this.saCategories.push(this.setChildNodesEmpty(source)); 
        if (source.Level == 3 && !this.saCategories.find(sa => sa.ID == parent.ID)) {
          let trade = this.setChildNodesEmpty(parent);
          trade.Children.push(this.setChildNodesEmpty(source));
          this.saCategories.push(trade); 
        }    
        if (x.Level == 4) {
          let trade = this.saCategories.find(x => x.ID == source.ParentID);
          let category = trade.Children.find(y => y.ID == source.ID);
          if (!category)
            trade.Children.push(this.setChildNodesEmpty(source));
          this.setChildNodes(trade.Children, source.ID, x);
          return;
        } 
        this.setChildNodes(this.saCategories, source.ID, x);
        return;
      } else {
        this.findChildNodes(x, id, source);
      }
    });
  }
  private setChildNodes(source, id, node) {
    source.forEach(x => {
      if (x.ID == id) {
        x.Children.push(this.setChildNodesEmpty(node));
      }
    });
  }
  private setChildNodesEmpty(source) {
    let node = Object.assign({}, source);
    node.Children = [];
    return node;
  }
}
